import { Reveal } from "@/components/Reveal";
import { QuoteForm } from "@/components/QuoteForm";
import { FAQ } from "@/components/FAQ";
import { Seo } from "@/components/Seo";
import { IMG } from "@/data/projects";

export default function Offerte() {
  return (
    <main data-testid="offerte-page" className="bg-white">
      <Seo
        title="Gratis Offerte Aanvragen | DEKO Kozijnen Noord-Nederland"
        description="Vraag vrijblijvend een offerte aan voor kunststof kozijnen, deuren of schuifpuien. Gratis inmeten aan huis, reactie binnen 1 werkdag, heel Noord-Nederland."
      />
      <section className="pt-40 pb-20 mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-5">
          <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Offerte aanvragen</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-[#2F3438] mt-5 leading-tight">Vrijblijvend en op maat.</h1>
          <p className="text-[#222]/60 text-lg font-light leading-relaxed mt-6 max-w-md">
            Laat uw gegevens achter en wij nemen binnen één werkdag contact met u op om een afspraak in te plannen. Geheel gratis en vrijblijvend.
          </p>
          <div className="mt-10 overflow-hidden rounded-sm aspect-[4/3] hidden lg:block">
            <img src={IMG.interiorLiving} alt="Interieur met kunststof kozijnen" className="h-full w-full object-cover" />
          </div>
          <div className="mt-8 space-y-2 text-sm text-[#222]/50">
            <div>Werkgebied — Noord-Nederland</div>
            <div>Reactie binnen 1 werkdag</div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="bg-white border border-[#ECECEA] rounded-sm p-8 sm:p-10">
            <QuoteForm />
          </div>
        </Reveal>
      </section>
      <FAQ />
    </main>
  );
}
